import React, { Component } from "react";
import { connect } from "react-redux";
import t from "tcomb-form";
import cn from "classnames";
import { Link } from "react-router-dom";
import { getForm } from "../lib/FormUtils";
import plans from "../lib/plans";
import { save } from "../actions/account";
import Loading from "../components/Loading";
import Switch from "../components/fields/Switch";

const paidPlans = plans.filter((p) => typeof p.price === "number");

const { schema, options } = getForm({
  billing_plan: {
    type: "string",
    required: true,
  },
});

const daysDiff = (date) => {
  const now = new Date();
  if (date.getTime() < now.getTime()) return 0;

  const timeDiff = Math.abs(now.getTime() - date.getTime());
  return Math.ceil(timeDiff / (1000 * 3600 * 24));
};

@connect((state) => ({ account: state.auth.account }), { save })
export default class extends Component {
  state = {
    value: {
      billing_plan: this.props.account.subscription.id,
    },
    annual: true,
    loading: false,
    error: "",
  };

  onChangeAnnual = (annual) => this.setState({ annual });

  onChange = (value) => this.setState({ value });

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    try {
      await this.props.save(this.state.value);
    } catch (err) {
      this.setState({ error: err._error });
    }

    this.setState({ loading: false });
  };

  render() {
    const { annual, value, loading, error } = this.state;
    const { account } = this.props;
    const planLabel = account.subscription.plan;
    // const isFreePlan = account.billing_plan === 'free' || account.billing_plan === 'trial'
    const trialEnd = new Date(account.subscription.trial_end * 1000);
    const daysRemaining = Math.max(0, daysDiff(trialEnd));
    const needsCard =
      value !== "free" && value !== "trial" && !account.billing_info;
    const canSave = !loading && !needsCard && value.billing_plan;
    const hasChange = account.subscription.id !== value.billing_plan;

    return (
      <form onSubmit={this.onSubmit} className="text-center">
        <div className="current-plan">
          <p>
            Your current plan is <strong>{planLabel}</strong>
          </p>
          {account.subscription.trial_end && (
            <p className={daysRemaining < 1 ? "text-danger" : ""}>
              {daysRemaining} days remaining
            </p>
          )}
        </div>
        <div className="flex items-center justify-center pb-4">
          <span className="text-muted pr-2">Annual pricing (save 25%):</span>
          <Switch value={annual} onChange={this.onChangeAnnual} />
        </div>
        <t.form.Form
          type={schema}
          value={value}
          onChange={this.onChange}
          options={{
            ...options,
            template: (locals) => (
              <div>
                {paidPlans.map((plan) => {
                  const id = `billing_plan_${plan.id}`;
                  const active =
                    locals.value.billing_plan ===
                    (annual ? plan.annualId : plan.id);

                  return (
                    <div key={id} className={cn("plan", { active })}>
                      <input
                        type="radio"
                        id={id}
                        value={annual ? plan.annualId : plan.id}
                        onChange={(e) =>
                          locals.onChange(
                            "billing_plan",
                            annual ? plan.annualId : plan.id
                          )
                        }
                        checked={active}
                      />
                      <label htmlFor={id} role="button" className="plan-body">
                        <h4>{plan.name}</h4>
                        {annual ? (
                          <p className="price">
                            <strong>${plan.annualPrice}</strong> / per month
                            <br />
                            <small className="text-muted">
                              Billed annually at ${plan.annualPrice * 12}
                            </small>
                          </p>
                        ) : (
                          <p className="price">
                            <strong>${plan.price}</strong> / per month
                          </p>
                        )}
                      </label>
                    </div>
                  );
                })}
              </div>
            ),
          }}
        />
        {needsCard && (
          <p className="text-danger">
            Payment method required for paid plans.{" "}
            <Link to="/dashboard/account/billing">Add Card</Link>
          </p>
        )}
        {loading && (
          <p>
            <Loading />
          </p>
        )}
        {!!error && <div className="error">{error}</div>}
        <button
          type="submit"
          className="btn btn-save"
          disabled={!canSave || !hasChange}
        >
          Save
        </button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./app/containers/AccountPlan.js